import get from 'lodash-es/get'
import * as React from 'react'

import Button from '../../buttons/button'
import { IItemCard } from '../interface'

import * as styles from './lockupPreviewButton.module.css'

const LockupPreviewButton = ({ item }: IItemCard) => {
  return (
    <Button
      role="button"
      className={styles.previewButton}
      href={get(item, 'previews.live_site.url')}
      target="_blank"
    >
      Preview
    </Button>
  )
}

export default LockupPreviewButton
